"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.describeBaseInfo = describeBaseInfo;
exports.queryHostedAccounts = queryHostedAccounts;
var _axios = _interopRequireDefault(require("@jdcloud/jelement-biz/dist/api/axios"));
var axios = new _axios.default({
  extra: {
    componentName: 'HostedAccounts'
  }
});

// 获取被托管账号
function queryHostedAccounts() {
  return axios({
    url: '/openApi/csa/queryHostedAccounts',
    method: 'POST'
  });
}

// 获取当前登录账号
function describeBaseInfo() {
  return axios({
    url: '/openApi/iam/describeBaseInfo',
    method: 'POST',
    data: {
      params: {
        pin: ''
      }
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/api/hosted-account-cascader.js
// module id = vvOA
// module chunks = 19